import { ApiProperty } from "@nestjs/swagger";

export class ShiftDto{

    @ApiProperty()
    id:number;

    @ApiProperty()
    shift:string;

    @ApiProperty()
    inTime:Date;

    @ApiProperty()
    outTime:Date;

    @ApiProperty()
    dayChange:string;

    @ApiProperty()
    isActive: boolean;

    createdAt: Date;

    @ApiProperty()
    createdUser: string;

    updatedAt: Date;

    @ApiProperty()
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;
}